export default {
  fields: {
    id: 'product_id',
    image: 'thumbnail',
    title: 'name',
    url: 'url',
  },
  getItemId: () =>
    window.cm_product?.[0] ?? window.document.querySelector('button[name="add-to-cart"]')?.value,
};
